import React, { Component } from 'react';
import { compose } from 'redux'
import { connect } from 'react-redux';
import './Intervention.css';
import withAuth from '../../components/withAuth';
import AppBar from '@material-ui/core/AppBar';
import FooterFixedOnScreen from '../Layout/FooterFixedOnScreen'
import Fab from "@material-ui/core/Fab";
import Icon from "@material-ui/core/Icon/Icon";
import { Button } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { withStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { getGpsPosition } from '../../redux/gps/gpsActions'
import Typography from '@material-ui/core/Typography';
import { searchCustomersNearGeolocation } from '../../redux/tiers/tiersActions'
import { createAndStartIntervention } from '../../redux/intervention/interventionEditionActions'
import { loadInterventionModel, getStartedWorkOrder } from '../../redux/intervention/interventionActions'
import moment from 'moment'
import { formatAddress } from '../../utils'
import ValidateIcon from '@material-ui/icons/Check';
import ComponentsPark from '../../containers/ComponentsPark/ComponentsPark'
import logo from '../../images/qr-code-icon.png';
import { throwErrorMessage, throwWarning } from '../../lib/error_helper';
import { getAffair } from '../../redux/affair/affairActions'
import { initializeDays } from '../../redux/day/dayEditionActions';
import { loadCurrentTimeSlot } from '../../redux/imputationInterventionRel/imputationInterventionRelActions';
import InterventionAlreadyInProgressModal from '../../components/Interventions/InterventionAlreadyInProgressModal'
import { clone } from '../../utils.js'
import { getStateAccessor } from '../../lib/evaluateStringAsCodeHelper';
import CustomizedTextField from '../../components/Input/CustomizedTextField';
import { getCurrentFunctionName } from '../../performanceModeManager';

const styles = () => ({
    appBar: {
        position: 'relative',
        marginBottom: '10px',
    },
    flex: {
        flex: 1,
    },
});

class CreateIntervention extends Component {

    constructor(props) {
        super(props);

        this.state = {
            equipmentModalOpenned: false,
            modalOpenned: false,
            affairModalOpenned: false,
            affairInput: "",
            customer: "",
            customerInput: "",
            equipmentInput: "",
            breakdown: "",
            comment: "",
            searchField: "",
            pauseInterventionModalOpenned: false,
            interventionToPause: null,
            gpsPosition: {
                lat: 0,
                lon: 0
            },
            gpsPositionSuccess: this.gpsPositionSuccess.bind(this),
        }

        this.props.loadInterventionModel();
    }

    componentDidMount() {
        if (navigator.geolocation) {
            // On démarre la géolocalisation
            this.props.getGpsPosition(this.props.authorizedApps)
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {

        if (nextProps.gpsPosition === prevState.gpsPosition)
            return prevState;

        let newState = clone(prevState);
        newState.gpsPosition = nextProps.gpsPosition
        prevState.gpsPositionSuccess(nextProps)

        return newState
    }

    pauseInterventionInProgress() {
        return new Promise((resolve) => {
            if (this.state.pauseInterventionModalOpenned)
                return resolve(false);

            getStartedWorkOrder().then(intervention => {
                if (intervention)
                    this.props.loadCurrentTimeSlot(intervention.report_block_ids, this.props.blocTypes, this.props.activeUser).then(timeSlot => {
                        if (timeSlot) {
                            this.setState({
                                interventionToPause: intervention,
                                pauseInterventionModalOpenned: true,
                            })

                            return resolve(true);
                        }
                    })
                else
                    return resolve(false);
            });
        })
    }

    closePauseInterventionModal() {
        this.setState({
            pauseInterventionModalOpenned: false,
        })
    }

    gpsClearWatch() {
        if (this.state.watchID) {
            navigator.geolocation.clearWatch(this.state.watchID);
            if (!this.isUnmounted) {
                this.setState({ watchID: null })
            }
        }
    }

    gpsPositionSuccess(props) {
        if (props.gpsPosition && props.gpsPosition.coords && props.gpsPosition.coords.accuracy < 300) {
            this.props.searchCustomersNearGeolocation(props.gpsPosition);
        }
    }

    gpsPositionError(e) {
        console.error(e);
        //this.gpsClearWatch();
    }

    add() {
        this.pauseInterventionInProgress().then(interventionIsInProgress => {
            if (interventionIsInProgress)
                return;

            this.props.initializeDays(this.props.activeUser.id);
            let today = moment(moment.utc().local());
            let technician = {
                name_related: this.props.activeUser.name,
                id: this.props.activeUser.emp_id
            }

            //Si client non renseigné alors commentaire obligatoire
            if (!this.state.customerInput) {
                this.props.throwErrorMessage({
                    title: "Erreur",
                    message: "Le champ client doit être renseigné",
                })

                return;
            }

            let comment = "";
            if (!this.props.resultSearchAffair)
                comment = comment.concat("Affaire: ").concat(this.state.affairInput).concat(" \r\n");

            comment = comment + "Client: " + this.state.customerInput + (this.state.customer ? " [" + this.state.customer.lastname + "]" : "") + " \r\n";
            comment = comment + "Commentaire: " + this.state.comment;

            let newIntervention = {
                type: "on_call",
                delivery_customer_id: this.state.customer,
                equipment: this.state.equipmentInput,
                equipment_description: this.state.equipmentInput,
                breakdown: this.state.breakdown,
                failure_description: this.state.breakdown,
                comment: comment,
                affair_id: this.props.resultSearchAffair ? this.props.resultSearchAffair.id : undefined,
                invoiced_customer_id: this.state.customer,
                date_call: today,
                date_planned_start: today,
                technician_ids: [technician],
                tec_manager_id: technician,
                name: "",
                allocation_label: "",
                internalState: "",
                duration_planned: 0
            };

            let imputationInformations = {
                startDate: moment().seconds(0).milliseconds(0),
                startTime: moment().seconds(0).milliseconds(0),
                gpsPosition: this.props.gpsPosition.coords
            }

            let stateAccessor = getStateAccessor(this.props)
            stateAccessor.intervention = newIntervention;
            this.props.createAndStartIntervention(newIntervention, this.props.activeUser, this.props.blocTypes, this.props.history, stateAccessor, imputationInformations);
        });
    }

    onClick() {
        this.setState({
            equipmentModalOpenned: true
        })
    }

    equipmentModalClose() {
        this.setState({
            equipmentModalOpenned: false
        })
    }

    cancel() {
        this.props.history.push("/interventions");
    }

    openModal() {
        this.setState({
            modalOpenned: true,
            customerInput: "",
        });
    }

    openAffairModal() {
        this.setState({
            modalAffairOpenned: true,
            affairInput: "",
        })
    }

    close() {
        this.setState({
            searchField: "",
            modalOpenned: false
        });
    }

    closeAffairModal() {
        this.setState({
            affairInput: "",
            modalAffairOpenned: false
        });
    }

    searchCustomer() {
        this.openModal();
    }

    searchAffair() {
        this.openAffairModal();
    }

    selectCustomer(customer) {
        let value = customer;
        this.setState({
            customer: value,
            customerInput: value.customer_code
        })

        this.close();
    }

    onCustomerChange(e) {
        let value = e.target.value;
        this.setState({
            customerInput: value,
            customer: undefined,
        })
    }

    selectEquipment(equipmentCode) {
        this.setState({
            equipmentInput: equipmentCode,
        })

        this.equipmentModalClose();
    }

    onEquipmentChange(e) {
        let value = e.target.value;
        this.setState({
            equipmentInput: value
        })
    }

    onBreakdownChange(e) {
        let value = e.target.value;
        this.setState({
            breakdown: value
        })
    }

    onCommentChange(e) {
        let value = e.target.value;
        this.setState({
            comment: value
        })
    }

    onAffairChange(e) {
        let value = e.target.value;

        if (this.state.affairTypingTimeout) {
            clearTimeout(this.state.affairTypingTimeout);
        }

        this.setState({
            affairInput: value,
            affairTypingTimeout: setTimeout(() => {
                this.props.getAffair(value, this.props.activeUser.id);
            }, this.state.timeout)
        });
    }

    visualizeEquipment(equipmentInput) {
        this.setState({
            equipmentInput
        })
    }

    validateVisualizingEquipment() {
        this.selectEquipment(this.state.equipmentInput);
    }

    cancelVisualizingEquipment() {
        this.setState({
            equipmentInput: "",
        })
    }

    onSearchFieldChange(e) {
        let value = e.target.value;

        this.setState({
            searchField: value
        })
    }

    customerElement = (c, i) => {
        return (
            <div key={i}>
                <ListItem alignItems="flex-start" button onClick={this.selectCustomer.bind(this, c)}>
                    <ListItemIcon>
                        <Icon>account_box</Icon>
                    </ListItemIcon>

                    <div className="row col-lg-12 col-md-12 col-sm-12 col-12">
                        <ListItemText className="col-lg-12 col-md-12 col-sm-12 col-12"
                            primary={"[" + c.customer_code + "]" + c.name}
                        />
                        <div className="col-lg-9 col-md-9 col-sm-9 col-8">
                            <Typography component="span" variant="caption" color="textPrimary">
                                {c.street + (c.street2 ? " - " + c.street2 : "")}
                            </Typography>
                            <Typography component="span" variant="caption" color="textPrimary">
                                {c.zip + " - " + c.city}
                            </Typography>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3 col-4">
                            <Typography component="span" variant="caption" color="textPrimary">
                                {c.distance ? (parseInt(c.distance) + " m") : ""}
                            </Typography>
                        </div>
                    </div>

                </ListItem>
                <Divider variant="inset" component="li" />
            </div>
        )
    }
    render() {
        console.perfLog(getCurrentFunctionName());
        const { classes } = this.props;

        let filteredCustomers = this.props.customers.filter(c => {
            let searchField = this.state.searchField.toLowerCase();
            let nameCondition = c.name.toLowerCase().includes(searchField);
            let codeCondition = c.customer_code.toLowerCase().includes(searchField);
            let addressCondition = c.street.toLowerCase().includes(searchField);
            let address2Condition = c.street2.toLowerCase().includes(searchField);

            return nameCondition || codeCondition || addressCondition || address2Condition;
        });

        let strAddress = "";
        let strCustomerName = "";

        if (this.state.customer) {
            strAddress = formatAddress(this.state.customer);
            strCustomerName = this.state.customer.name;
        }

        const nbMaxCustomersToDisplay = 30;
        if (filteredCustomers.length > nbMaxCustomersToDisplay)
            filteredCustomers = filteredCustomers.slice(0, nbMaxCustomersToDisplay);

        return (
            <div className="without-side-padding">
                <Card className="card col-lg-12 col-md-12 col-sm-12 col-12 without-side-margin without-side-padding">
                    <CardContent className="col-lg-12 col-md-12 col-sm-12 col-12 row without-side-padding">
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12 row">
                            <div className="col-lg-10 col-md-10 col-sm-10 col-9 without-side-padding">
                                <CustomizedTextField label={"Client"} onChange={this.onCustomerChange.bind(this)}
                                    value={this.state.customerInput} className="full_size" />
                            </div>
                            <div className="col-lg-2 col-md-2 col-sm-2 col-3 control-inline-btn">
                                <Button variant="contained" size="small" onClick={this.searchCustomer.bind(this)}>
                                    <Icon>search</Icon>
                                </Button>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <CustomizedTextField label={"Nom"} className="light-disabled full_size"
                                value={strCustomerName} />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <CustomizedTextField label={"Adresse"} className="light-disabled full_size" multiline
                                value={strAddress} />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="row">
                                <div className="col-lg-10 col-md-10 col-sm-10 col-9 without-side-padding">
                                    <CustomizedTextField label={"Equipement"} onChange={this.onEquipmentChange.bind(this)}
                                        value={this.state.equipmentInput} className="full_size" />
                                </div>
                                <div className="col-lg-2 col-md-2 col-sm-2 col-3 control-inline-btn">
                                    <Button variant="contained" size="small" onClick={this.onClick.bind(this)}>
                                        <img src={logo} alt="QR code" width={32} height={32} />
                                    </Button>
                                </div>
                                <Dialog open={this.state.equipmentModalOpenned} onClose={this.handleClose} fullScreen aria-labelledby="form-dialog-title">
                                    <AppBar className={classes.appBar}>
                                        <Toolbar>
                                            <IconButton color="inherit" onClick={this.equipmentModalClose.bind(this)} aria-label="Close">
                                                <CloseIcon />
                                            </IconButton>
                                            <Typography variant="h6" color="inherit" className={classes.flex}>
                                                {"Equipement"}
                                            </Typography>
                                            <IconButton color="inherit" onClick={this.validateVisualizingEquipment.bind(this)} aria-label="Validate">
                                                <ValidateIcon />
                                            </IconButton>
                                        </Toolbar>
                                    </AppBar>
                                    <DialogContent className="without-side-padding">
                                        <ComponentsPark modalMode selectEquipment={this.selectEquipment.bind(this)}
                                            visualizeEquipment={this.visualizeEquipment.bind(this)}
                                            cancelVisualizingEquipment={this.cancelVisualizingEquipment.bind(this)} />
                                    </DialogContent>
                                </Dialog>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <CustomizedTextField label={"Panne"} onChange={this.onBreakdownChange.bind(this)}
                                value={this.state.breakdown} className="full_size" />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="row">
                                <div className="col-lg-10 col-md-10 col-sm-10 col-9 without-side-padding">
                                    <CustomizedTextField
                                        id="affair"
                                        key="affair"
                                        label={"Affaire"}
                                        className="full_size"
                                        value={this.state.affairInput}
                                        onChange={this.onAffairChange.bind(this)}
                                    />
                                </div>
                                <div className="col-lg-2 col-md-2 col-sm-2 col-3 control-inline-btn create-intervention-margin-icon">
                                    {this.props.resultSearchAffair ? (<Icon color="primary">check</Icon>) : (<Icon color="secondary">clear</Icon>)}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <CustomizedTextField label={"Commentaire"} onChange={this.onCommentChange.bind(this)}
                                value={this.state.comment} className="full_size" multiline />
                        </div>
                        <FooterFixedOnScreen>
                            <div className="row">
                                <div className="col-lg-2 col-md-2 col-sm-4 col-4">
                                    <Fab onClick={this.cancel.bind(this)}
                                        className="div-center">
                                        <Icon>arrow_back</Icon>
                                    </Fab>
                                    <span className="floating-btn-text span-center">Annuler</span>
                                </div>
                                <div className="offset-lg-8 col-lg-2 offset-md-8 col-md-2 offset-sm-4 col-sm-4 offset-4 col-4">
                                    <div className="center">
                                        <Fab onClick={this.add.bind(this)}
                                            className="red-button div-center">
                                            <Icon>add</Icon>
                                        </Fab>
                                        <span className="floating-btn-text span-center">Créer</span>
                                    </div>
                                </div>
                            </div>
                        </FooterFixedOnScreen>
                        <Dialog aria-labelledby="simple-dialog-title" fullScreen open={this.state.modalOpenned}
                            onClose={this.close.bind(this)}>
                            <AppBar className={classes.appBar}>
                                <Toolbar>
                                    <IconButton color="inherit" onClick={this.close.bind(this)} aria-label="Close">
                                        <CloseIcon />
                                    </IconButton>
                                    <Typography variant="h6" color="inherit" className={classes.flex}>
                                        {"Sélection client"}
                                    </Typography>
                                </Toolbar>
                            </AppBar>
                            <DialogContent className="without-side-padding">
                                <Card className="card col-lg-12 col-md-12 col-sm-12 col-12 without-side-margin">
                                    <CardContent className="col-lg-12 col-md-12 col-sm-12 col-12 row without-side-padding">
                                        <CustomizedTextField label={"Recherche"} onChange={this.onSearchFieldChange.bind(this)}
                                            value={this.state.searchField} className="full_size" />
                                    </CardContent>
                                </Card>
                                <Card className="card col-lg-12 col-md-12 col-sm-12 col-12 without-side-margin">
                                    <CardContent className="col-lg-12 col-md-12 col-sm-12 col-12 row without-side-padding">
                                        <List component="nav">
                                            {filteredCustomers.map(this.customerElement.bind(this))}
                                        </List>
                                        <div className="row">
                                            <Typography variant="caption" color="inherit">
                                                {filteredCustomers.length === nbMaxCustomersToDisplay ? "Recherche limitée à " + nbMaxCustomersToDisplay + " résultats" : null}
                                            </Typography>
                                        </div>

                                    </CardContent>
                                </Card>
                            </DialogContent>
                        </Dialog>
                    </CardContent>
                </Card>
                <InterventionAlreadyInProgressModal interventionInProgress={this.state.interventionToPause}
                    opened={this.state.pauseInterventionModalOpenned} closeModal={this.closePauseInterventionModal.bind(this)} />
            </div>

        )
    }
}

const mapStateToProps = (state) => {
    return {
        customers: state.tiers.customers,
        activeUser: state.activeUser,
        blocTypes: state.interventions.blocTypes,
        resultSearchAffair: state.affair.resultSearchAffair,
        currentDay: state.current_day,
        gpsPosition: state.gpsInformations.gpsPosition,
        authorizedApps: state.authorizedApps,
        loggedEmployee: state.loggedEmployee.loggedEmployee,
        fluidBottles: state.liquidBottles.myLiquidBottles,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadInterventionModel: () => dispatch(loadInterventionModel()),
        searchCustomersNearGeolocation: (position) => dispatch(searchCustomersNearGeolocation(position)),
        createAndStartIntervention: (intervention, user, blocTypes, history, stateAccessor, imputationInformations) => dispatch(createAndStartIntervention(intervention, user, blocTypes, history, stateAccessor, imputationInformations)),
        throwErrorMessage: (errorObj) => dispatch(throwErrorMessage(errorObj)),
        throwWarning: (warnObj) => dispatch(throwWarning(warnObj)),
        getAffair: (code, userId) => dispatch(getAffair(code, userId)),
        getGpsPosition: (authorizedApps) => dispatch(getGpsPosition(authorizedApps)),
        initializeDays: (userId) => dispatch(initializeDays(userId)),
        loadCurrentTimeSlot: (blocs, blocTypes, user) => dispatch(loadCurrentTimeSlot(blocs, blocTypes, user)),
    };
};

export default compose(withStyles(styles), withAuth, connect(mapStateToProps, mapDispatchToProps))(CreateIntervention);
